import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import {makeStyles} from "@material-ui/core";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'rgb(84, 86, 95)',
    color: 'white'
  },
  buttonRow: {
    backgroundColor: 'rgb(84, 86, 95)',
    color: 'white',
    padding: 24,
  },
  textWhite: {
    color: 'white',
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 400,
  },
  buttonStyleFilled: {
    background: '#F62459',
    color: '#FFF',
    padding: '8px 20px',
    '&:hover': {
      background: '#C93756'
    },
  },
});

export default function TransferUrlPopup({ isOpen, handleClose, refundAmount, ticketTransferUri}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const getUrl = window.location;
  const baseUrl = getUrl.protocol + '//' + getUrl.host + '/resale/';

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Snackbar open={open} autoHideDuration={3000} onClose={() => setOpen(false)}>
        <SnackbarContent
          style={{
            backgroundColor: '#2e7d32'
          }}
          message={
            <span id="client-snackbar" style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <CheckCircleIcon style={{fontSize: 20, marginRight: 10}}/>
                URL copied!
            </span>
          }
          action={
            <IconButton color="inherit" onClick={() => setOpen(false)}>
              <CloseIcon style={{fontSize: 20}}/>
            </IconButton>
          }
        />
      </Snackbar>

      <DialogTitle className={classes.root} id="form-dialog-title">TRANSFER URL</DialogTitle>
      <DialogContent className={classes.root}>
        <div className={classes.textWhite}>
          Once someone buys your ticket through link provided below, you will receive a refund
          of {refundAmount} directly onto the credit/debit card that was used to purchase the ticket within
          5 to 10 business days.
        </div>
        <div
          style={{display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'white', padding: 5, marginTop: 16, borderRadius: 4}}
          onClick={() => {
            navigator.clipboard.writeText(baseUrl + ticketTransferUri);
            setOpen(true);
          }}
        >
          <div style={{color: 'black', flex: 1, textAlign: 'center', fontSize: '0.875rem', wordBreak: 'break-all'}}>
            {baseUrl}{ticketTransferUri}
          </div>
          <Hidden xsDown>
            <Button
              color="primary"
              className={classes.buttonStyleFilled}
            >
              COPY
            </Button>
          </Hidden>
        </div>
      </DialogContent>
      <DialogActions className={classes.buttonRow}>
        <Button className={classes.textWhite} onClick={handleClose} color="primary">
          CLOSE
        </Button>
        <Button
          onClick={() => window.open(baseUrl + ticketTransferUri, '_blank')}
          color="primary"
          className={classes.buttonStyleFilled}
        >
          OPEN URL
        </Button>
      </DialogActions>
    </Dialog>
  );
}
